import { useAsmRouter } from 'src/utils/hooks';

export function useGetShopLocationShortName() {
  const router = useAsmRouter();
  if (typeof router.query.id === 'string' && router.query.id.length > 0) {
    return router.query.id;
  }
  return null;
}
